var _defs, _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPolkadotJs(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 106.2 106.2",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("style", null, ".cls-2{fill:#fff}"))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_2",
    "data-name": "Layer 2"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Layer_1-2",
    "data-name": "Layer 1"
  }, /*#__PURE__*/React.createElement("circle", {
    cx: 53.1,
    cy: 53.1,
    r: 53.1,
    fill: "#f29235"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M54.47 13.76a28.85 28.85 0 00-28.73 28.73 29.34 29.34 0 001.52 9.34 4 4 0 107.49-2.52A18.67 18.67 0 0133.63 42a20.72 20.72 0 1122 21.31s-4 .25-6 .49c-.74.11-1.48.26-2.2.44a.28.28 0 01-.38 0 .27.27 0 010-.32l.63-3.41 3.79-17a3.94 3.94 0 10-7.71-1.65s-9 41.7-9 42.08a3.79 3.79 0 002.74 4.6h.28a3.78 3.78 0 004.61-2.71.43.43 0 000-.11v-.19c.11-.49 1.25-6 1.25-6a10.23 10.23 0 018.46-8c.87-.13 4.53-.38 4.53-.38a28.71 28.71 0 00-2.11-57.27z"
  }), /*#__PURE__*/React.createElement("path", {
    className: "cls-2",
    d: "M56.21 80a4.78 4.78 0 00-5.66 3.71.24.24 0 010 .08 4.77 4.77 0 003.65 5.67h.14A4.7 4.7 0 0060 86v-.32A5 5 0 0056.21 80z"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPolkadotJs);
export default __webpack_public_path__ + "static/media/polkadot_js.af39156828a1006e1c5ddeff76f2e107.svg";
export { ForwardRef as ReactComponent };